'use client';

import { CustomErrorView } from 'src/components/custom-error/custom-error-view';

export default function ErrorBoundary({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return <CustomErrorView error={error} reset={reset} />;
}
